module.exports = __webpack_public_path__ + "img/headLogo.039f5752.png";